/* src/app/views/doctor/doctors-list/doctors-list.component.css */
/*# sourceMappingURL=doctors-list.component.css.map */
